import { render } from "./ActiveEmployeeListWidget.vue?vue&type=template&id=5e076292&scoped=true"
import script from "./ActiveEmployeeListWidget.vue?vue&type=script&lang=js"
export * from "./ActiveEmployeeListWidget.vue?vue&type=script&lang=js"

import "./active-employee-list-widget.scss?vue&type=style&index=0&id=5e076292&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e076292"]])

export default __exports__